import {
  ConfigProvider,
  Divider,
  Drawer,
  Input,
  Select,
  Space,
  Spin,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import style from "css/address.module.css";
import { CloseOutlined, SettingOutlined } from "@ant-design/icons";
import AddressInputField from "./addressInputField";
import axios from "axios";
import { useTranslation } from "react-i18next";
const { TextArea } = Input;

function AddressPopup({ isOpen, closePopup, info, tagList }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [type, setType] = useState("");
  const [data, setData] = useState({});
  const [tags, setTags] = useState([]);
  const colorTemplate = [
    { txt_color: "#65a5e0", bg_color: "#dcedfc" },
    { txt_color: "#1cb691", bg_color: "#def5e9" },
    { txt_color: "#fd9800", bg_color: "#fef0d4" },
  ];

  useEffect(() => {
    if (isOpen) {
      if (info !== undefined && info !== null) {
        setData(info);
        setType("edit");
      } else {
        setData({});
        setType("add");
      }
      setIsLoading(false);
      setTags(tagList);
    }
  }, [info, isOpen, tagList]);

  const labelToKey = (list) => {
    let result = [];
    tags.forEach((el) => {
      const label = el.label;
      const obj = list.filter((tag) => tag === label);

      if (obj.length > 0) {
        result.push(el);
      }
    });
    return result;
  };

  const saveEvent = () => {
    if (data.name === undefined || data.name === "") {
      message.error(t("MESSAGE.CONTACT_NAME_EMPTY"));
      return;
    }

    setIsLoading(true);
    const url = "/address/info";
    let axiosData = {
      name: data.name,
      email: data.email,
      tel: data.tel,
      memo: data.memo,
    };

    if (data.tag !== undefined && data.tag.length > 0) {
      axiosData.tags = labelToKey(data.tag);
    }

    if (type === "add") {
      axios
        .post(url, axiosData)
        .then((res) => {
          if (res.status === 200) {
            message.success(t("MESSAGE.CONTACT_REGISTER_SUCCESS"));
            closeHandler();
          }
        })
        .catch((err) => message.error(t("MESSAGE.CONTACT_REGISTER_FAIL")))
        .finally(() => {
          setIsLoading(false);
        });
    } else if (type === "edit") {
      axiosData.address_id = data.key;
      axiosData.favorite_yn = data.favorite;

      if (info.tag !== undefined && info.tag.length > 0) {
        axiosData.origin_tags = labelToKey(info.tag);
      }

      axios
        .put(url, axiosData)
        .then((res) => {
          if (res.status === 200) {
            message.success(t("MESSAGE.CONTACT_MODIFY_SUCCESS"));
            closeHandler();
          }
        })
        .catch((err) => message.error(t("MESSAGE.CONTACT_MODIFY_FAIL")))
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const selectTag = (list) => {
    let result = [];
    list.forEach((value) => {
      let obj = tags.filter((el) => el.label === value)[0];
      if (obj === undefined) {
        result.push(value);
      } else {
        result.push(obj.label);
      }
    });
    setData({
      ...data,
      tag: result,
    });
  };
  const deleteTag = (label) => {
    const result = data.tag.filter((el) => el !== label);
    setData({
      ...data,
      tag: result,
    });
  };
  const tagRender = ({ label, value }) => {
    const obj = tags.filter((el) => el.label === label)[0];
    const color = colorTemplate[Math.floor(Math.random() * 3)];
    return (
      <div
        className={style.info_popup_select_item}
        style={{
          color: obj === undefined ? color.txt_color : obj.txt_color,
          backgroundColor: obj === undefined ? color.bg_color : obj.bg_color,
          fill: obj === undefined ? color.txt_color : obj.txt_color,
        }}
        key={value}
      >
        {label}
        <CloseOutlined className="cursor" onClick={() => deleteTag(label)} />
      </div>
    );
  };
  const filterOption = (input, option) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  };
  const valueRender = (list) => {
    let arr = [];
    list.forEach((tag) => {
      const obj = tags.filter((el) => el.label === tag)[0];
      const color = colorTemplate[Math.floor(Math.random() * 3)];
      if (obj === undefined) {
        arr.push({
          label: tag,
          value: tag,
        });
        setTags([
          ...tags,
          {
            label: tag,
            txt_color: color.txt_color,
            bg_color: color.bg_color,
          },
        ]);
      } else {
        arr.push({
          label: obj.label,
          value: obj.label,
        });
      }
    });
    return arr;
  };
  const selectItemRender = (menu) => {
    return (
      <>
        {menu}
        <Divider style={{ margin: "8px 0" }} />
        <Space className={style.info_popup_select_setting_btn}>
          <SettingOutlined
            className="cursor"
            onClick={() => {
              closeHandler();
              // openTagPopup();
            }}
          />
        </Space>
      </>
    );
  };

  const closeHandler = () => {
    setType("");
    setData({});
    closePopup();
  };

  return (
    <Drawer
      placement="bottom"
      open={isOpen}
      onClose={closeHandler}
      closable={false}
      maskClosable={false}
      height="100vh"
    >
      <ConfigProvider
        theme={{
          components: {
            Input: {
              colorBorder: "#b4b4b4",
              colorPrimary: "#fff",
              colorPrimaryHover: "#1cb691",
              controlItemBgActive: "#1cb691",
              controlItemBgHover: "#1cb691",
            },
          },
        }}
      >
        <div className={style.addr_popup_container}>
          <div className={style.addr_popup_header}>
            <div className={style.popup_title}>
              {type === "add"
                ? t("LABEL.TITLE.ADD_CONTACT")
                : t("LABEL.TITLE.MODIFY_CONTACT")}
            </div>
            <CloseOutlined
              className={style.popup_close}
              onClick={closeHandler}
            />
          </div>
          <div className={style.addr_popup_content}>
            <div style={{ width: "100%" }}>
              <AddressInputField
                label={t("LIST.NAME")}
                child={
                  <Input
                    className={style.addr_popup_textInput}
                    value={data.name}
                    placeholder={t("PLACEHOLDER.INPUT.ENTER_NAME")}
                    onChange={(e) => setData({ ...data, name: e.target.value })}
                  />
                }
              />
            </div>
            <div style={{ width: "100%" }}>
              <AddressInputField
                label={t("LIST.EMAIL")}
                child={
                  <Input
                    className={style.addr_popup_textInput}
                    value={data.email}
                    placeholder={t("PLACEHOLDER.INPUT.ENTER_EMAIL")}
                    onChange={(e) =>
                      setData({ ...data, email: e.target.value })
                    }
                  />
                }
              />
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div style={{ width: "54%" }}>
                <AddressInputField
                  label={t("LIST.PHONE")}
                  child={
                    <Input
                      className={style.addr_popup_textInput}
                      value={data.tel}
                      placeholder={t("PLACEHOLDER.INPUT.ENTER_PHONE")}
                      onChange={(e) =>
                        setData({ ...data, tel: e.target.value })
                      }
                    />
                  }
                />
              </div>
              <div style={{ width: "43%" }}>
                <AddressInputField
                  label={t("LIST.GROUP")}
                  child={
                    <ConfigProvider
                      theme={{
                        components: {
                          Select: {
                            colorBorder: "#b4b4b4",
                            colorIcon: "#707070",
                            colorPrimary: "#fff",
                            colorPrimaryHover: "#1cb691",
                            controlItemBgActive: "#1cb691",
                            controlItemBgHover: "#1cb691",
                          },
                        },
                      }}
                    >
                      <Select
                        style={{ height: "45px" }}
                        className="addr_popup_select"
                        mode="tags"
                        value={
                          data.tag !== undefined && data.tag.length > 0
                            ? valueRender(data.tag)
                            : []
                        }
                        options={(tags || []).map((el) => ({
                          label: el.label,
                          value: el.label,
                        }))}
                        onChange={selectTag}
                        tagRender={tagRender}
                        notFoundContent={null}
                        filterOption={filterOption}
                        maxTagCount={"responsive"}
                        dropdownRender={(menu) => selectItemRender(menu)}
                      />
                    </ConfigProvider>
                  }
                />
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <AddressInputField
                label={t("LIST.MEMO")}
                child={
                  <TextArea
                    className={style.addr_popup_textInput}
                    value={data.memo}
                    placeholder={t("PLACEHOLDER.INPUT.WRITE_CONTENT")}
                    onChange={(e) => setData({ ...data, memo: e.target.value })}
                  />
                }
              />
            </div>
          </div>
          <div className={style.addr_popup_footer}>
            <button className={style.cancelBtn} onClick={closeHandler}>
              {t("BTN.CANCEL")}
            </button>
            <button className={style.saveBtn} onClick={saveEvent}>
              {isLoading ? (
                <ConfigProvider
                  theme={{
                    components: {
                      Spin: {
                        colorPrimary: "#fff",
                      },
                    },
                  }}
                >
                  <Spin />
                </ConfigProvider>
              ) : (
                t("BTN.SAVE")
              )}
            </button>
          </div>
        </div>
      </ConfigProvider>
    </Drawer>
  );
}

export default AddressPopup;
